<div v-if="showWrappingSelection">
  <div @click="openOverlay" class="selection-holder">
    <div class="text" :class="{ 'has-value': selectedWrappingOption }">
      <div class="label">{{ $t('shopping.basket.checkout.packaging') }}</div>
      <div class="value" v-if="selectedWrappingOption">{{ selectedWrappingLabel }}</div>
    </div>
    <div class="icon iconfont-triangle-right"></div>
  </div>
  
  <BaseModal v-model="isModalOpen" :bottomSheetOnMobile="true">
    <template #header>{{ $t('shopping.basket.checkout.packaging') }}</template>
    <NBRadioGroup wrapper-class="packaging-radio-group" v-model="selectedWrappingOption" @update:modelValue="handleSelect" :options="wrappingOptions" valueKey="type">
      <template #default="{ option }">
        <div class="label" v-html="option.description"></div>
      </template>
    </NBRadioGroup>
  </BaseModal>
</div>
